export const ACKNOWLEDGEMENT_TEXT_1 =
  'I understand there will be no shift training and only a brief orientation for shifts I book through Medely. I will read all shift details and ensure I am skilled in performing all required duties before booking shifts.';

export const ACKNOWLEDGEMENT_TEXT_2 =
  "I understand that no-shows and late cancellations (cancelling less than 24 hours prior to start time) directly impact patient care, are non-compliant with Medely's terms of service, and may result in deactivation of my account.";
